import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Plus } from 'lucide-react';
interface FaqItemProps {
  id: string;
  question: string;
  answer: string;
  open: boolean;
  onToggle: () => void;
}
export function FaqItem({
  id,
  question,
  answer,
  open,
  onToggle
}: FaqItemProps) {
  return <div className="border-b border-gunmetal" data-id="element-134" data-mp="35668wxplrld4">
      <h3 className="font-sans" data-id="element-135" data-mp="353sg6vieal8q">
        <button type="button" id={`${id}-trigger`} aria-expanded={open} aria-controls={`${id}-panel`} onClick={onToggle} className="flex w-full items-center justify-between gap-6 py-6 text-left text-base font-medium text-bone transition-colors duration-150 hover:text-white md:text-lg" data-id="element-136" data-mp="28fvxnl3edfuv">
          {question}
          <Plus aria-hidden="true" className={`h-5 w-5 shrink-0 text-steel transition-transform duration-200 ease-out ${open ? 'rotate-45' : ''}`} data-id="element-137" data-mp="2m8vd5n36ja2f" />
        </button>
      </h3>
      <AnimatePresence initial={false} data-id="element-138" data-mp="1badwoki8q9ou">
        {open && <motion.div id={`${id}-panel`} role="region" aria-labelledby={`${id}-trigger`} initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="overflow-hidden" data-id="element-139" data-mp="1b9ucex54b97n">
            <p className="max-w-2xl pb-6 text-base leading-relaxed text-steel" data-id="element-140" data-mp="rny455sw7nnu">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}